import { useMemo } from "react";
import "../../../../../../styles/Pages/Financial/CashOutFlow/AcademicEx/Salaries/SalarySlip.style.css";

// Component for rendering the title section
const TitleSection = ({ schoolName, logo }) => (
  <div className="titleSection">
    <img src={logo} alt="School Logo" />
    <h2>{schoolName}</h2>
  </div>
);

// Component for rendering slip details
const SlipDetails = ({ id, dateTime }) => (
  <div className="billDetail">
    <div>
      Salary Slip ID: <span>{id}</span>
    </div>
    <div>
      Date and Time: <span>{dateTime}</span>
    </div>
  </div>
);

// Component for rendering employee details
const EmployeeDetails = ({ employee }) => (
  <div className="employeeDetails">
    <div className="NameID">
      <h2>{employee.name}</h2>
      <span>{employee.id}</span>
    </div>
    <div className="PositionGrade">
      <div>{employee.position}</div>
      <div>
        Grade: <span id="grade">{employee.grade}</span>
      </div>
    </div>
    <div className="contact">
      <div>
        Contact: <span id="phone">{employee.contact}</span>
      </div>
    </div>
    <div className="address">
      Address: <span>{employee.address}</span>
    </div>
  </div>
);

// Component for rendering billing section
const BillingSection = ({ billing, totalGrossSalary }) => (
  <div className="billSection">
    <div className="billHeader">
      <span>Month For</span>
      <span>Total salary (INR)</span>
      <span>Gross salary (INR)</span>
    </div>
    <div className="billBody">
      {billing.map((data, index) => (
        <div className="billContent" key={index}>
          <span>{data.monthFor}</span>
          <span>₹ {data.totalSalary.toLocaleString("en-IN")}</span>
          <span>₹ {data.grossSalary.toLocaleString("en-IN")}</span>
        </div>
      ))}
    </div>
    <div className="solid-line" />
    <div className="total">
      <span>Total</span>
      <span>₹ {totalGrossSalary.toLocaleString("en-IN")}</span>
    </div>
  </div>
);

// Component for rendering additional info
const OthersSection = ({ others }) => (
  <div className="others">
    <p>{others.payScaleNote}</p>
    <p className="tag">
      Payment Mode: <span>{others.paymentMode}</span>
    </p>
    <p className="tag">
      Dispatched By: <span>{others.dispatchedBy}</span>
    </p>
  </div>
);

// Component for rendering footer
const FooterSection = () => (
  <div className="bottom">
    <span>Official Seal</span>
    <span id="signatory">Authorised signatory</span>
  </div>
);

const SalarySlip = ({ salarySlipData }) => {
  const { school, slipDetails, employee, billing, others } = salarySlipData;

  const totalGrossSalary = useMemo(() => {
    return billing.reduce((total, item) => total + item.grossSalary, 0);
  }, [billing]);

  return (
    <div className="salarySlipContainer">
      <div className="text-content">
        <TitleSection schoolName={school.name} logo={school.logo} />
        <h4 style={{ color: "var(--blueColor1)" }}>SALARY SLIP</h4>
        <SlipDetails id={slipDetails.id} dateTime={slipDetails.dateTime} />
        <EmployeeDetails employee={employee} />
        <div className="dashed-line" />
        <BillingSection billing={billing} totalGrossSalary={totalGrossSalary} />
        <OthersSection others={others} />
        <FooterSection />
      </div>
    </div>
  );
};

export default SalarySlip;
